import moment from 'moment';
import lowerCase from 'lodash/lowerCase';
import upperFirst from 'lodash/upperFirst';
import type { TFunction } from 'i18next';

// threshold to show 'not seen recently'
const NOT_SEEN_HOURS = 12;

export const ACTIVATED_SIM_STATUS = 'ACTIVATED';

interface SimHealthInput {
  status: string | null;
  last_seen: string | null;
}

// the sim collection job stores 1970 when three has no location history
export const getSimLastSeen = (lastSeen: string | null) =>
  lastSeen && moment(lastSeen).year() > 1970 ? moment(lastSeen) : null;

// null sim means it wasn't found in our sim details
export const getSimHealth = (sim: SimHealthInput | null, t: TFunction) => {
  if (!sim) {
    return { label: t('sim.details.not.found'), isHealthy: false };
  }

  if (sim.status !== ACTIVATED_SIM_STATUS) {
    return {
      label: sim.status ? upperFirst(lowerCase(sim.status)) : t('sim.details.unknown.status'),
      isHealthy: false,
    };
  }

  const lastSeen = getSimLastSeen(sim.last_seen);
  if (!lastSeen || moment().diff(lastSeen, 'hours') >= NOT_SEEN_HOURS) {
    return { label: t('sim.details.not.seen'), isHealthy: false };
  }

  return { label: t('sim.details.active'), isHealthy: true };
};
